import React, { Component } from "react";
import { Loader } from "react-loaders";
import { Link } from "react-router";

import { batchRequest } from "../api/ApiService";
import Teams from "../api/Teams";

import ResultsValuationsResults from "../containers/ResultsValuationsResults";
import ExpandImage from "../containers/assets/icon_expand.svg";

import CompetitiveAnalysis from "../components/ceo/analysis/widgets/competitive-analysis";
import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import ResultsPanelBalanceSheet from "../components/results/ResultsPanelBalanceSheet";
import ResultsPanelIncomeStatement from "../components/results/ResultsPanelIncomeStatement";
import ResultsPanelCashFlows from "../components/results/ResultsPanelCashFlows";

import { logError, detectMobile } from "../services/utils";
import TypeformContent from "../components/typeform/TypeformContent";

class Results extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: "income",
      data: {},
      teams: {},
      metrics: {},
      loaded: false,
      valuationsResults: {
        pricetoEarnings: {
          name: "Price to Earnings",
          data: {}
        },
        marketValue: {
          name: "Market Value",
          data: {}
        },
        pricetoSales: {
          name: "Price to Sales",
          data: {}
        },
        pricetoBook: {
          name: "Price to Book",
          data: {}
        }
      },
      roundInUrl: props.roundInUrl,
      currentRound: props.currentRound
    };

    this.isMobile = detectMobile();
  }

  getCompetitiveAnalysis() {
    const rounds = this.props.rounds;

    const base_url = `${process.env.REACT_APP_API_URL}competition/competitive_analysis/`;
    let url = "";
    if (
      this.state.roundInUrl !== null &&
      this.state.roundInUrl !== this.state.currentRound
    ) {
      let round = rounds.find(i => i.number === this.state.roundInUrl);
      if (round) {
        url = `${base_url}?round=${round.id}`;
      }
    } else {
      let round = rounds.find(i => i.number === this.state.currentRound);
      if (round) {
        if (round.is_finished === true) {
          url = `${base_url}?round=${round.id}`;
        } else {
          const round_number = this.state.currentRound - 1;
          if (round_number > 0) {
            round = rounds.find(i => i.number === round_number);
            if (round) {
              url = `${base_url}?round=${round.id}`;
            }
          }
        }
      }
    }

    if (url === "") {
      return null;
    }

    return url;
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound
    ) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  getCompetitionMetrics() {
    const { currentRound, roundInUrl } = this.props;
    const base_url = `${process.env.REACT_APP_API_URL}competition/metrics/`;

    let activeRound = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      activeRound = roundInUrl;
    }

    return `${base_url}?round_number=${activeRound}`;
  }

  fetchData = () => {
    let teams = {};
    let data = {};
    let valuationsResults = { ...this.state.valuationsResults };

    Teams.teams().forEach(item => {
      teams[item.id] = item.name;
      data[item.id] = {};
      valuationsResults.pricetoEarnings.data[item.id] = 0;
      valuationsResults.marketValue.data[item.id] = 0;
      valuationsResults.pricetoSales.data[item.id] = 0;
      valuationsResults.pricetoBook.data[item.id] = 0;
    });

    this.setState(
      {
        teams,
        data,
        valuationsResults
      },
      () => {
        this.loadState();
      }
    );
  };

  componentDidMount() {
    this.fetchData();
  }

  getRequests = () => {
    const request1 = this.getCompetitiveAnalysis();
    const request2 = this.getCompetitionMetrics();

    if (!request1) {
      return batchRequest([request2]);
    }

    return batchRequest([request2, request1]);
  };

  loadState = () => {
    const joinRequest = this.getRequests();

    this.setState({
      loaded: false
    });

    return joinRequest
      .then(res => {
        const valuationsResults = { ...this.state.valuationsResults };
        const res0 = res[0].body;

        for (let key in valuationsResults) {
          res0.forEach(response => {
            const hash = valuationsResults[key].name;
            if (
              response[hash] &&
              response.team in valuationsResults[key].data
            ) {
              valuationsResults[key].data[response.team] = response[hash];
            }
          });
        }

        let metrics = {};
        let data = this.state.data;

        if (res.length > 1) {
          const res1 = res[1].body;
          const exclude_keys = [
            "created_at",
            "id",
            "is_actual",
            "reason",
            "round",
            "team",
            "updated_at"
          ];

          res1.forEach(item => {
            if (item.team in data) {
              Object.keys(item).forEach(key => {
                if (exclude_keys.includes(key)) {
                  return;
                }

                data[item.team][key] = item[key] === null ? 0 : item[key];
              });
            }
          });

          res0.forEach(row => {
            metrics[row.team] = {
              MarketShare: row["Market Share"] ? row["Market Share"] : 0,
              Revenues: row["Net Revenues"] ? row["Net Revenues"] : 0,
              GrossMargins: row["Gross Margin"] ? row["Gross Margin"] : 0
            };
          });
        }

        this.setState({
          data,
          valuationsResults,
          metrics,
          loaded: true
        });
      })
      .catch(err => {
        logError(err, "Results", "loadState");
      });
  };

  updateActive = e => {
    const { statement } = e.target.dataset;

    let currentStatement = document.querySelector(".statement.active");
    let nextStatement = document.querySelector("." + statement);

    currentStatement.classList.add("hidden");
    currentStatement.classList.remove("active");

    nextStatement.classList.add("active");
    nextStatement.classList.remove("hidden");

    this.setState({
      active: statement
    });
  };

  get activeRound() {
    const { currentRound, roundInUrl } = this.state;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return roundInUrl;
    }

    return currentRound;
  }

  render() {
    const { valuationsResults, metrics, roundInUrl, currentRound } = this.state;

    return (
      <section className="analysis">
        {this.state.loaded ? (
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="container-analysis report-collapse">
                <h3 className="semibold">
                  Financials
                  <HelpIconButtonWithTooltipAndTypeformModal
                    {...TypeformContent.FINANCIALS}
                  />
                  <Link
                    to="/pd/results/FinancialAnalysis"
                    className="icon-zoom"
                  >
                    <img src={ExpandImage} className="icon" alt="ExpandImage" />
                  </Link>
                </h3>
                <div className="panel-dashboard-white">
                  <div className="results-submenu">
                    <button
                      className="mr-15 pointer"
                      data-statement="income"
                      onClick={this.updateActive}
                    >
                      INCOME STATEMENT
                    </button>
                    <button
                      className="mr-15 pointer"
                      data-statement="balance"
                      onClick={this.updateActive}
                    >
                      BALANCE SHEET
                    </button>
                    <button
                      className="mr-15 pointer"
                      data-statement="cash"
                      onClick={this.updateActive}
                    >
                      CASH FLOWS
                    </button>
                  </div>
                  <div className="statement income active mt-30">
                    <ResultsPanelIncomeStatement
                      rounds={this.props.rounds}
                      currentRound={currentRound}
                      roundInUrl={roundInUrl}
                    />
                  </div>
                  <div className="statement balance hidden mt-30">
                    <ResultsPanelBalanceSheet
                      rounds={this.props.rounds}
                      currentRound={currentRound}
                      roundInUrl={roundInUrl}
                    />
                  </div>
                  <div className="statement cash hidden mt-30">
                    <ResultsPanelCashFlows
                      rounds={this.props.rounds}
                      currentRound={currentRound}
                      roundInUrl={roundInUrl}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xs-12">
              <CompetitiveAnalysis
                teams={this.state.teams}
                data={this.state.data}
                metrics={metrics}
                activeRound={this.activeRound}
                currentRound={currentRound}
                roundInUrl={roundInUrl}
              />
              <ResultsValuationsResults
                valuationsResults={valuationsResults}
                teams={this.state.teams}
              />
            </div>
          </div>
        ) : (
          <Loader type="ball-scale-ripple" active />
        )}
      </section>
    );
  }
}

export default Results;



// WEBPACK FOOTER //
// ./src/containers/Results.js